import React, { useEffect, useRef } from 'react';
import { People, Star, Favorite, CheckCircle, Security, Assignment } from '@mui/icons-material';
import { Instagram, Language, WebAsset as WebAssetIcon } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
import image1 from '../../assets/images/Image_fx.jpg'
import image2 from '../../assets/images/Image_fx2.jpg'
import image3 from '../../assets/images/Image_fx3.jpg'
import image4 from '../../assets/images/Image_fx4.jpg'
import image5 from '../../assets/images/Image_fx5.jpeg'
import image6 from '../../assets/images/Image_fx6.jpg'
import image7 from '../../assets/images/Image_fx7.jpg'
import image8 from '../../assets/images/Image_fx8.jpg'
import image9 from '../../assets/images/Image_fx9.jpg'
import '../../styles/custom.css';
const AboutSection = () => {
  const theme = useTheme();
  const sectionRef = useRef(null);

  // Values data with icons
  const values = [
    {
      icon: 'users',
      title: 'Community',
      description: 'Building lasting relationships and supporting each other\'s fitness journey',
      iconSvg: <People className="svg-icon" />
    },
    {
      icon: 'trophy',
      title: 'Excellence',
      description: 'Striving for the highest standards in training, equipment, and service',
      iconSvg: <Star className="svg-icon" />
    },
    {
      icon: 'heart',
      title: 'Inclusivity',
      description: 'Welcoming fitness enthusiasts of all ages, abilities, and backgrounds',
      iconSvg: <Favorite className="svg-icon" />
    },
    {
      icon: 'dumbbell',
      title: 'Results',
      description: 'Committed to helping every member achieve their personal fitness goals',
      iconSvg: <CheckCircle className="svg-icon" />
    }
  ];

  // Trainer data
 const trainers = [
  {
    name: 'Sarah Johnson',
    title: 'Head Personal Trainer',
    experience: '8 Years Experience',
    specializations: ['Strength Training', 'Weight Loss', 'Nutrition'],
    certifications: ['NASM-CPT', 'Precision Nutrition'],
    bio: 'Sarah founded Varsity Fitness with a vision to create an inclusive space where everyone feels empowered to reach their fitness goals. Her expertise in strength training and nutrition has helped hundreds of clients transform their lives.',
    image: image1,
    website: 'https://sarahjohnsonfit.com',
    instagram: 'https://instagram.com/sarahjohnsonfit',
  },
  {
    name: 'Mike Rodriguez',
    title: 'Senior Personal Trainer',
    experience: '6 Years Experience',
    specializations: ['Athletic Performance', 'Functional Training', 'Injury Prevention'],
    certifications: ['ACSM-CPT', 'FMS Level 2'],
    bio: 'Mike brings his background in sports performance to help clients of all levels achieve their athletic potential. His focus on functional movement and injury prevention ensures safe, effective training for everyone.',
    image: image2,
    website: 'https://mikerodriguezfit.com',
    instagram: 'https://instagram.com/mikerodriguezfit',
  },
  {
    name: 'Emily Chen',
    title: 'Yoga & Flexibility Specialist',
    experience: '5 Years Experience',
    specializations: ['Yoga', 'Pilates', 'Mobility Training'],
    certifications: ['RYT-500', 'PMA-CPT'],
    bio: 'Emily specializes in helping clients improve flexibility, balance, and mind-body connection. Her holistic approach combines traditional yoga practices with modern fitness techniques for complete wellness.',
    image: image3,
    website: 'https://emilychenfit.com',
    instagram: 'https://instagram.com/emilychenfit',
  },
  {
    name: 'Marcus Thompson',
    title: 'HIIT & Cardio Specialist',
    experience: '7 Years Experience',
    specializations: ['HIIT', 'Cardio Conditioning', 'Boot Camp'],
    certifications: ['ACE-CPT', 'CrossFit Level 2'],
    bio: 'Marcus is known for his high-energy classes that push clients beyond their limits. His dynamic training style and motivational coaching help clients achieve peak cardiovascular fitness and endurance.',
    image: image4,
    website: 'https://marcusthompsonfit.com',
    instagram: 'https://instagram.com/marcusthompsonfit',
  },
  {
    name: 'Jessica Martinez',
    title: 'Fitness Specialist',
    experience: '4 Years Experience',
    specializations: ['Prenatal Fitness', 'Postpartum Recovery', 'Core Rehabilitation'],
    certifications: ['NASM-CPT', 'Pre/Postnatal Certified'],
    bio: 'Jessica provides safe and effective fitness programs for expecting and new mothers. Her compassionate approach helps women maintain strength and wellness throughout their pregnancy journey and beyond.',
    image: image5,
    website: 'https://jessicamartinezfit.com',
    instagram: 'https://instagram.com/jessicamartinezfit',
  },
  {
    name: 'David Kim',
    title: 'Bodybuilding',
    experience: '9 Years Experience',
    specializations: ['Bodybuilding', 'Muscle Growth', 'Competition Prep'],
    certifications: ['ISSA-CPT', 'ISSA Bodybuilding Specialist'],
    bio: 'David has competed professionally and now helps clients build muscle and sculpt their physiques. His detailed programming and nutrition guidance have helped numerous clients achieve their body composition goals.',
      image: image6,
    website: 'https://davidkimfit.com',
    instagram: 'https://instagram.com/davidkimfit',
  },
  {
    name: 'Rachel Williams',
    title: 'Senior Wellness Coach',
    experience: '6 Years Experience',
    specializations: ['Weight Management', 'Lifestyle Coaching', 'Group Fitness'],
    certifications: ['ACE-CPT', 'Health Coach Certification'],
    bio: 'Rachel takes a holistic approach to fitness, focusing on sustainable lifestyle changes. Her supportive coaching style and group fitness expertise create a motivating environment for lasting transformation.',
    image: image7,
    website: 'https://rachelwilliamsfit.com',
    instagram: 'https://instagram.com/rachelwilliamsfit',
  },
  {
    name: 'Alex Turner',
    title: 'Sports Performance Coach',
    experience: '5 Years Experience',
    specializations: ['Speed Training', 'Agility', 'Sport-Specific Training'],
    certifications: ['CSCS', 'USAW Sports Performance'],
    bio: 'Alex works with athletes looking to elevate their game. His expertise in speed, agility, and power development helps athletes gain the competitive edge they need to excel in their sport.',
    image: image8,
    website: 'https://alexturnerfit.com',
    instagram: 'https://instagram.com/alexturnerfit',
  },
  {
    name: 'Olivia Patel',
    title: 'Strength & Conditioning Coach',
    experience: '7 Years Experience',
    specializations: ['Powerlifting', 'Olympic Lifting', 'Strength Development'],
    certifications: ['NSCA-CSCS', 'USAW Level 1'],
    bio: 'Olivia is passionate about teaching proper lifting techniques and building raw strength. Her technical expertise and patient teaching style help clients master complex movements and reach new personal records.',
    image: image9,
    website: 'https://oliviapatelfit.com',
    instagram: 'https://instagram.com/oliviapatelfit',
  }
];

  // Animation functions
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    // Observe sections
    if (sectionRef.current) {
      const sections = sectionRef.current.querySelectorAll('.about-section-content');
      sections.forEach(section => observer.observe(section));
    }

    return () => observer.disconnect();
  });

  return (
    <div className="about-section" ref={sectionRef}>
      {/* Hero Section */}
     {/*  <div className="about-hero">
        <div className="hero-content">
          <h1>About Varsity Fitness</h1>
          <p>Where strength is earned, legacy is honored, and every person finds their place on the team</p>
        </div>
      </div> */}
        {/* Hero Section */}
{/*       <Box sx={{ bgcolor: 'background.paper', py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2rem', md: '3rem' },
                fontWeight: 600,
                mb: 3,
                maxWidth: '100%',
                textAlign: 'center'
              }}
            >
              About <Box component="span" sx={{ color: theme.palette.primary.main }}>Varsity Fitness</Box><br />
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: '1.125rem', maxWidth: 600, mx: 'auto' }}>
              Where strength is earned, legacy is honored, and every person finds their place on the team
            </Typography>
          </Box>
        </Container>
      </Box> */}

      {/* Our Story Section */}
      <section className="about-section-content">
        <div className="about-container">
          <div className="section-header">
            <h2 className="section-title">Our Story</h2>
            <p className="section-subtitle">The foundation that built our strength</p>
          </div>
          <div className="content-grid">
            <div className="content-text">
              <p>Founded with a vision to create more than just a gym, Varsity Fitness has become a community where champions are made and lifelong friendships are forged. Our journey began with a simple belief: that fitness isn't just about building muscle, but about building character and cultivating an environment where everyone can thrive.</p>
              <p>What sets us apart is our commitment to personalized training experiences and our dedication to helping members achieve not just their physical goals, but their personal aspirations as well. From state-of-the-art equipment to expert guidance, we provide everything you need to transform your body and elevate your life.</p>
            </div>
            <div className="content-visual">
              <div className="icon-container">
                <Security className="svg-icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="about-section-content">
        <div className="about-container">
          <div className="section-header">
            <h2 className="section-title">Our Vision</h2>
            <p className="section-subtitle">Charting the path forward</p>
          </div>
          <div className="content-grid">
            <div className="content-visual">
              <div className="icon-container">
                <CheckCircle className="svg-icon" />
              </div>
            </div>
            <div className="content-text">
              <p>Our vision extends beyond fitness goals and weight loss milestones. We envision a world where every individual discovers their inner strength, finds their community, and develops the confidence to pursue their dreams.</p>
              <p>We're building more than a gym; we're creating a movement. A movement that inspires people to push their limits, support one another, and recognize that true strength comes from within. Our vision is simple yet profound: to be the catalyst that transforms not just bodies, but lives.</p>
            </div>
          </div>


        </div>
      </section>

      {/* Core Values Section */}
      <section className="about-section-content">
        <div className="about-container">
          <div className="section-header">
            <h2 className="section-title">Our Core Values</h2>
            <p className="section-subtitle">The principles that guide every decision</p>
          </div>

          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-item">
                <div className="value-icon-circle">
                  {value.iconSvg}
                </div>
                <h3 style={{color: '#333', fontSize: '1.3rem', marginBottom: '15px'}}>{value.title}</h3>
                <p style={{color: '#666', fontSize: '1rem', lineHeight: '1.6'}}>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Mission Section */}
      <section className="about-section-content">
        <div className="about-container">
          <div className="section-header">
            <h2 className="section-title">Our Mission</h2>
            <p className="section-subtitle">Our promise to you</p>
          </div>
          <div className="content-grid">
            <div className="content-text">
              <p>Our mission is to create more than just fit bodies—we create confident individuals who believe in themselves and inspire others. Every member who walks through our doors becomes part of our family, and we are committed to their success.</p>
              <p>We don't just provide equipment and classes; we provide the motivation, the knowledge, and the support system you need to succeed. Our mission drives us to innovate, to listen, and to constantly improve the ways we help our community achieve their goals.</p>
            </div>
            <div className="content-visual">
              <div className="icon-container">
                <Assignment className="svg-icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* In Memoriam Section */}
      <section className="in-memoriam-section">
        <div className="about-container">
          <div className="memoriam-content">
            <h2 className="memoriam-heading">In Memoriam</h2>
            <div className="memoriam-photo-container">
              <img 
                src={image1} 
                alt="Emre Comertoglu" 
                className="memoriam-photo"
              />
            </div>
            <h3 className="memoriam-name">Emre Comertoglu</h3>
            <p className="memoriam-years">1978 – 2026</p>
            <div className="memoriam-tribute">
              <p>
                Varsity Fitness honors our visionary co-founder, Emre Comertoglu. 
                Emre's passion for health and his dedication to the Long Beach community 
                shaped the foundation of everything we do. His infectious energy and 
                commitment to helping others reach their full potential left an indelible 
                mark on all of us.
              </p>
              <p>
                We carry his mission forward with every workout and every life changed. 
                He is deeply missed, but his spirit remains the driving force of our gym.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutSection;
